"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvailableVideoTabs = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useTabContent_1 = require("./useTabContent");
function useAvailableVideoTabs() {
    var _a, _b, _c, _d;
    const exercises = (0, useTabContent_1.useTabContent)(bridge_schema_1.InfoBoxTabType.VideosExercises);
    const treatments = (0, useTabContent_1.useTabContent)(bridge_schema_1.InfoBoxTabType.VideosTreatments);
    const stretches = (0, useTabContent_1.useTabContent)(bridge_schema_1.InfoBoxTabType.VideosStretches);
    const conditions = (0, useTabContent_1.useTabContent)(bridge_schema_1.InfoBoxTabType.VideosConditions);
    const result = [];
    if ((_a = exercises.items) === null || _a === void 0 ? void 0 : _a.length) {
        result.push(bridge_schema_1.InfoBoxTabType.VideosExercises);
    }
    if ((_b = treatments.items) === null || _b === void 0 ? void 0 : _b.length) {
        result.push(bridge_schema_1.InfoBoxTabType.VideosTreatments);
    }
    if ((_c = stretches.items) === null || _c === void 0 ? void 0 : _c.length) {
        result.push(bridge_schema_1.InfoBoxTabType.VideosStretches);
    }
    if ((_d = conditions.items) === null || _d === void 0 ? void 0 : _d.length) {
        result.push(bridge_schema_1.InfoBoxTabType.VideosConditions);
    }
    return result;
}
exports.useAvailableVideoTabs = useAvailableVideoTabs;
